import { SkillPlate } from './components/SkillPlate';
import { LeftPanel } from './components/LeftPanel';
import { RightPanel } from './components/RightPanel';
import './App.css';

function App() {
    return (
        <div className="app">
            <header className="app-header">
                <div className="header-left">
                    <h1 className="app-title">诛仙世界 · 天工机巧盘模拟器</h1>
                    <span className="app-subtitle">S4 碧落凡心</span>
                </div>
                <div className="header-right">
                    <span className="header-info">拖放石头到棋盘进行模拟放置</span>
                </div>
            </header>

            <main className="app-main">
                <aside className="panel-left">
                    <LeftPanel />
                </aside>

                <section className="panel-center">
                    <SkillPlate />
                </section>

                <aside className="panel-right">
                    <RightPanel />
                </aside>
            </main>

            <footer className="app-footer">
                <span>数据来源：诛仙世界 S4 赛季官方公告</span>
                <span className="footer-sep">|</span>
                <span>机巧石形状：T形 · 田形 · 左L形 · 右L形</span>
                <span className="footer-sep">|</span>
                <span>匠心石：固定田形（2×2）</span>
            </footer>
        </div>
    );
}

export default App;